import { SxStyle } from '@aibees/shared/theme';
import { alpha } from '@mui/material';

export const head: SxStyle = {
  backgroundColor: (p) => p.palette.grey[500],
};

export const tableContainer: SxStyle = {
  overflow: 'auto',
  scrollbarWidth: 'thin',
  scrollbarColor: (p) => alpha(p.palette.grey[600], 0.48) + ' transparent',
};
